<template>
  <b-card
    v-if="data"
    no-body
    class="card-revenue-budget"
  >
    <b-row class="mx-0">
      <b-col
        md="12"
        class="revenue-report-wrapper"
      >
        <div class="d-sm-flex justify-content-between align-items-center mb-3">
          <h4 class="card-title mb-50 mb-sm-0 chart-title">
            {{ $t('Monthly Order') }}
            <tooltip-help text="This chart illustrates the total of all orders added in the respective month, specifically displaying data from the past 12 months." />
          </h4>
          <b-button
            v-if="showRefreshButton"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            size="sm"
            variant="outline-primary"
            class="widgetrefresh-button d-sm-flex align-items-center justify-content-center shadow-custom"
            :style="cardBorder"
            @click="refreshWidget"
          >
            <feather-icon
              icon="RefreshCwIcon"
              class="mr-50 refresh-icon"
            />
            <span class="align-middle refresh-span" />
            <time-ago
              :datetime="lastUpdatedAt"
              class="timeAgo"
              refresh
              locale="en"
              :long="true"
              :style="{color: '#1C1F32'}"
            />
          </b-button>
        </div>

        <!-- chart -->
        <vue-apex-charts
          id="revenue-report-chart"
          type="bar"
          height="230"
          :options="revenueReport.chartOptions"
          :series="data.series"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BButton,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Ripple from 'vue-ripple-directive'
import { TimeAgo } from 'vue2-timeago'
import RefreshMixin from '@/@core/mixins/ui/refresh'
import TooltipHelp from './TooltipHelp.vue'

export default {
  components: {
    VueApexCharts,
    BCard,
    BRow,
    BCol,
    TimeAgo,
    BButton,
    TooltipHelp,
  },
  directives: {
    Ripple,
  },
  mixins: [RefreshMixin],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    lastUpdatedAt: {
      type: String,
      default: null,
    },
    queue: {
      type: String,
      required: true,
    },
    showRefreshButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      revenue_report: {},
      revenueReport: {
        chartOptions: {
          chart: {
            type: 'bar',
            height: 320,
            toolbar: { show: false },
          },
          stroke: {
            width: 0,
          },
          grid: {
            padding: {
              top: -20,
              bottom: -10,
            },
            yaxis: {
              lines: {
                show: true,
                dashArray: 4,
              },
            },
          },
          xaxis: {
            categories: this.data.categories.lables,
            labels: {
              rotate: -45,
              style: {
                colors: '#6E6B7B',
                fontSize: '0.86rem',
                fontFamily: 'Montserrat',
              },
            },
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          plotOptions: {
            bar: {
              columnWidth: this.getColumnWidth(),
              borderRadius: 6, // This will round all corners of the bars
              distributed: false,
            },
          },
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'light',
              type: 'vertical',
              shadeIntensity: 0,
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
              colorStops: [
                [
                  {
                    offset: 0,
                    color: '#325BCB', // Bottom color for bar 1
                    opacity: 1,
                  },
                  {
                    offset: 100,
                    color: '#17378F', // Top color for bar 1
                    opacity: 1,
                  },
                ],
              ],
            },
          },
          yaxis: {
            labels: {
              formatter(value) {
                return value.toLocaleString()
              },
              style: {
                colors: '#6E6B7B',
                fontSize: '0.86rem',
                fontFamily: 'Montserrat',
              },
            },
          },
          tooltip: {
            enabled: true,
            custom({ series, seriesIndex, dataPointIndex }) {
              const value = series[seriesIndex][dataPointIndex]
              return `
              <div
              class="custom-tooltip"
              style="
                padding: 2px 14px;
                background: #325BCB;
                color: #FFF;
                border-radius: 20px;
                font-size: 14px;
                font-weight: 600;
              "
            >
              ${value.toLocaleString()}</div>`
            },
          },
          responsive: [
            {
              breakpoint: 767,
              options: {
                dataLabels: {
                  style: {
                    fontSize: '7px',
                  },
                },
              },
            },
          ],
        },
      },
    }
  },
  computed: {
    cardBorder() {
      return {
        border: '1px solid var(--primary) !important',
      }
    },
  },
  methods: {
    getColumnWidth() {
      const count = this.data?.categories?.lables?.length || 0

      if (count === 1) return '5px'
      if (count === 2) return '6px'
      return '40px'
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../@core/scss/vue/pages/widget-refresh.scss';
.refresh-icon {
  color: #1C1F32;
}
</style>
